import { render, staticRenderFns } from "./PurchaserList.vue?vue&type=template&id=62e8ecdb&scoped=true"
import script from "./PurchaserList.vue?vue&type=script&lang=js"
export * from "./PurchaserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e8ecdb",
  null
  
)

export default component.exports